import styled from 'styled-components';
import { COLORS, FONTS } from '@stelecom/ui-react/assets/js/constants';
import { CollapsedMenu } from '~/src/components/Header/styled';

export const RightCollapsedMenu = styled(CollapsedMenu)`
    white-space: nowrap;
    flex-direction: column;
    align-items: flex-end;
    left: auto;
    right: -16px;
    transform: translate(0, 0);
    ${FONTS.XXS};
    top: 85%;

    a, span {
        color: ${COLORS.black};
        transition: color .3s ease;
        ${FONTS.Medium};
        
        &:hover {
            color: ${COLORS.red};
        }
    }
`;
